import axios, { AxiosInstance } from 'axios';
import { auth } from '@/store';
import { API_URL } from '../const';

const request: AxiosInstance = axios.create({
  baseURL: API_URL,
});

request.interceptors.request.use(
  (config) => {
    if (auth.token) {
      config.headers.Authorization = `Bearer ${auth.token}`;
      // utils.getQueryString('accessToken')
    }
    return config;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  },
);

request.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 500) {
    console.error(error.response.data);
  }
  return Promise.reject(error);
});

export default request;
